import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  image?: string;
  url?: string;
  type?: string;
  keywords?: string;
  rating?: number;
  playCount?: number;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  image = '/images/touzi.png',
  url = 'https://randplays.com',
  type = 'website',
  keywords,
  rating,
  playCount
}) => {
  const fullTitle = `${title}`;
  const fullUrl = url.startsWith('http') ? url : `https://randplays.com${url}`;
  const fullImage = image.startsWith('http') ? image : `https://randplays.com${image}`;
  const defaultKeywords = 'free online games, browser games, casual games, mobile games, HTML5 games';
  const metaKeywords = keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords;

  // 直接更新 document.title
  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={metaKeywords} key="keywords" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      {rating && <meta property="og:rating" content={rating.toString()} />}
      {playCount && <meta property="og:playCount" content={playCount.toString()} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Game specific meta tags */}
      {type === 'game' && (
        <>
          <meta name="game:title" content={title} />
          <meta name="game:description" content={description} />
          {rating && <meta name="game:rating" content={rating.toString()} />}
          {playCount && <meta name="game:playCount" content={playCount.toString()} />}
        </>
      )}

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO; 